import { getFeatureFlags } from 'utils/featureFlags';

export const getMinSuggestChars = () => (getFeatureFlags().eagerSuggest ? 2 : 3);
